import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { IonIcon, Button } from 'controls'
import styles, { cardWithIconStyle, closabledCardStyle } from './styles'

const SimpleCardWithIcon = ({
  icon = 'md-flash',
  title = 'Título',
  content,
  className,
  ...rest
}) => (
  <Card className={className} {...rest}>
    <div className="content-card-icon">
      {typeof icon === 'string' ? <IonIcon icon={icon} size="large" /> : icon}
      {title && <h5 className="title">{title}</h5>}
      {content && <div className="content"> {content}</div>}
    </div>
    <style jsx>{cardWithIconStyle}</style>
  </Card>
)

const ClosabledCard = ({ handleClose, children, ...rest }) => (
  <div className="closabled-card">
    <Button className="closabled-card-button" onClick={handleClose}>
      <IonIcon icon="md-close" />
    </Button>
    <Card {...rest}>{children}</Card>
    <style jsx>{closabledCardStyle}</style>
  </div>
)

const Card = ({
  children,
  title,
  action,
  className,
  bordered,
  borderedDashed,
  shadow,
  success,
  error,
  warning,
  small,
  fat,
  titleFat,
  rounded,
  gray,
  enableHover,
  alignCenter = true,
  alignRight,
  alignLeft,
  maxWidth,
  minHeight,
  noPadding,
  style = {}
}) => (
  <Fragment>
    {title && (
      <div
        className={classnames('wrapper-card card-title', className, {
          bordered,
          borderedDashed,
          shadow,
          success,
          error,
          warning,
          noPadding,
          small,
          titleFat,
          gray,
          rounded,
          enableHover,
          'without-border': !bordered && !borderedDashed,
        })}
        style={{ maxWidth }}
      >
        {title}
        {action && <div className="action">{action}</div>}
      </div>
    )}
    <div
      className={classnames('wrapper-card', className, {
        bordered,
        borderedDashed,
        shadow,
        success,
        error,
        warning,
        noPadding,
        small,
        gray,
        rounded,
        fat,
        alignCenter,
        alignRight,
        alignLeft,
        enableHover,
        'without-border': !bordered && !borderedDashed,
      })}
      style={{ maxWidth, minHeight, ...style }}
    >
      {children}
    </div>
    <style jsx>{styles}</style>
  </Fragment>
)

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.any
  ]).isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.any
  ]),
  className: PropTypes.string,
  bordered: PropTypes.bool,
  shadow: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.bool,
  warning: PropTypes.bool,
  small: PropTypes.bool,
  fat: PropTypes.bool,
  titleFat: PropTypes.bool,
  gray: PropTypes.bool
}

export default Card
export { SimpleCardWithIcon, ClosabledCard }
